"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PF_STORAGE_KEY = 'pf-last-evaluation';
class InMemoryStorage {
    constructor() {
        this._evaluation = null;
    }
    get() {
        return this._evaluation;
    }
    persist(evaluation) {
        if (JSON.stringify(evaluation) !== JSON.stringify(this.get())) {
            this._evaluation = evaluation;
            return true;
        }
        return false;
    }
}
exports.InMemoryStorage = InMemoryStorage;
class SessionStorage {
    get() {
        try {
            return JSON.parse(sessionStorage.getItem(exports.PF_STORAGE_KEY));
        }
        catch (e) {
            return null;
        }
    }
    persist(evaluation) {
        if (JSON.stringify(evaluation) !== JSON.stringify(this.get())) {
            sessionStorage.setItem(exports.PF_STORAGE_KEY, JSON.stringify(evaluation));
            return true;
        }
        return false;
    }
}
exports.SessionStorage = SessionStorage;
class PersistentStorage {
    get() {
        try {
            return JSON.parse(localStorage.getItem(exports.PF_STORAGE_KEY));
        }
        catch (e) {
            return null;
        }
    }
    persist(evaluation) {
        if (JSON.stringify(evaluation) !== JSON.stringify(this.get())) {
            localStorage.setItem(exports.PF_STORAGE_KEY, JSON.stringify(evaluation));
            return true;
        }
        return false;
    }
}
exports.PersistentStorage = PersistentStorage;
//# sourceMappingURL=Storage.js.map